import { getAuthorizedScormClient } from "../../client/svcClients";
import { getCurrentSelectedTenant, getTenantUuid } from "../../utils";

export type ScormLesson = {
  lessonKey: string;
  name: string;
  description: string;
};

export const generateScormPackage = async ({ lessons = [] }: { lessons: ScormLesson[] }) => {
  if (!lessons?.length) {
    throw new Error("No lessons provided");
  }

  const tenantUuid = await getTenantUuid();
  if (!tenantUuid) {
    throw new Error("Tenant UUID not found");
  }

  const tenant = getCurrentSelectedTenant();
  if (!tenant) {
    throw new Error("No tenant selected");
  }

  const scormClient = await getAuthorizedScormClient();

  const payload = {
    idpUuid: tenantUuid,
    tenant,
    courses: lessons.map(({ name, lessonKey, description }) => ({
      title: name,
      lessonKey,
      description,
    })),
  };

  return await scormClient.generateScormPackage(payload).promise;
};
